<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        width="12"
        height="12">
        <rect
            width="12"
            height="12"
            x="0"
            y="0"
            :fill="color"
            rx="2" />
    </svg>
</template>

<script>
export default {
    name: 'ProductAreaIcon',
    props: {
        color: {
            type: String,
            required: true,
        },
    },
};
</script>
